import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { CreateRiskInsightsResponse } from '../risk-insights/models/riskInsights';

type RiskInsightsState = {
  loading: boolean;
  error?: string;
  data?: CreateRiskInsightsResponse;
};

const initialState: RiskInsightsState = {
  loading: false,
  data: undefined,
  error: undefined,
};

export const riskInsightsSlice = createSlice({
  name: 'risk-insights',
  initialState,
  reducers: {
    createRiskInsightsStart: (state) => {
      state.loading = true;
      state.error = undefined;
    },
    createRiskInsightsSuccess: (state, action: PayloadAction<CreateRiskInsightsResponse>) => {
      state.loading = false;
      state.data = action.payload;
    },
    createRiskInsightsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { createRiskInsightsStart, createRiskInsightsSuccess, createRiskInsightsFailure } =
  riskInsightsSlice.actions;
